import { Box } from "@mui/material";
import { Layout } from "../Components/layout";
import { ProductDetails } from "../Components/product_management/product_details";
import { DeliveryManagement } from "../Components/delivery_management/delivery_management";
import { UserManagement } from "../Components/user_management";
import { Sidebar } from "../Components/sidebar";
import { Header } from "../Components/header";
import { Dashboard } from "../Components/dashboard";
import { useDispatch, useSelector } from "react-redux";
import { Inventory } from "../Components/product_management/inventory";
import { Campaign } from "../Components/product_management/campaign";
import { OrederManagement } from "../Components/order_management/order_lists";
import { Category } from "../Components/settings/category_management";
import { SubCategory } from "../Components/settings/sub_category_management";
import axios from 'axios';
import { useEffect, useState, useMemo, useCallback } from "react";
import { updateFirst_name, updateId, updateLast_name } from "../Redux/user";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { useFetchOrders, useGetOrders } from "../Components/globalFunctions"
import { updatepageName, updatesocketStatus } from "../Redux/page";
import { updateSelectedHub } from "../Redux/user";
import { InventoryBatchList } from "../Components/product_management/inventoryBatchList";
import useOrderSoundNotification from "../hooks/useOrderSoundNotification";
import useWebPubSubOrders from "../hooks/useWebPubSubOrders";
import { BatchHistory } from "../Components/product_management/batch_history";
import { OfferManagement } from "../Components/offer_management/offer_details";
import { GeneralSettings } from "../Components/settings/general_settings";
import { Campaign_Push_notification } from "../Components/campaign/campaign_push_notification";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
export function Home() {
  const location = useLocation();
  const navigate = useNavigate();
  const isKioskPage = location.pathname.includes('kiosk_order');
  const page = useSelector(state => state.page.pageName)
  console.log(page)
  const id = localStorage.getItem('id');
  const authToken = localStorage.getItem('authtoken');
  const first_name = localStorage.getItem('first_name');
  const last_name = localStorage.getItem('last_name');
  const user_role = localStorage.getItem('role');
  const orderDate = useSelector(state => state.orders.selectedDate)
  // Memoize today to prevent unnecessary re-renders
  const today = useMemo(() => dayjs(), []);
  const toast = useRef(null);
  const hasRefreshedOrdersRef = useRef(false);
  const lastKnownOrderIdsRef = useRef(new Set()); // Track order IDs to detect new ones
  const snapshotBeforeDisconnectRef = useRef(new Set()); // Snapshot of order IDs before disconnection
  const wasDisconnectedRef = useRef(false); // Track if we were disconnected
  const missedOrderTimeoutsRef = useRef([]); // Track timeouts for missed order audio playback
  const processedOrderIdsRef = useRef(new Set()); // Track processed order IDs to prevent duplicates
  const lastProcessedOrderIdsRef = useRef(new Set()); // Track last processed order IDs for real-time detection
  const ordersBeforeRefreshRef = useRef(new Set()); // Track orders before API refresh to detect new ones
  const previousTotalOrdersRef = useRef(0); // Track previous totalOrders count to detect changes
  const ordersBeforeStallFilterRef = useRef(new Set()); // Track orders before stall filter effect to detect new ones
  const orderCountWhenNetworkBackRef = useRef(0); // Track order count when network comes back online (before PubSub reconnects)
  const networkCameBackRef = useRef(false); // Track if network just came back online
  const toastShownForCurrentRefreshRef = useRef(false); // Track if toast was already shown for current refresh cycle (to prevent duplicate toasts)
  const pubSubOrderBatchRef = useRef([]);
  const pubSubBatchTimeoutRef = useRef(null);
  const pubSubNotificationAtRef = useRef(0);

   //console.log(id)
  const dispatch = useDispatch()
  
  // Redirect cashiers to order management if they try to access other pages
  useEffect(() => {
    if (user_role === 'cashier' && !location.pathname.includes('order_management') && !location.pathname.includes('kiosk_order')) {
      navigate('/home/order_management');
    }
  }, [user_role, location.pathname, navigate]);
  
  useEffect(() => {
    dispatch(updateFirst_name(first_name))
    dispatch(updateLast_name(last_name));
    dispatch(updateId(id));

  }, [authToken])
  
  // Refresh orders when connection is established (only once per connection)
  const GetOrders = useFetchOrders();
  
  const refreshOrdersList = useCallback(() => {
    if (orderDate != null) {
      GetOrders(orderDate[0], orderDate[1]);
    } else {
      GetOrders(today, today);
    }
  }, [GetOrders, orderDate, today]);

  // Get orders from Redux to detect new ones
  // IMPORTANT: useFetchOrders updates filteredOrders, not orders!
  // MUST be declared BEFORE useEffects that use it
  const orders = useSelector(state => state.orders.filteredOrders || state.orders.orders);
  
  // Audio only — Channels WebSocket removed; Web PubSub drives notifications.
  const { playOrderSound, unlockAudio } = useOrderSoundNotification({
    socketUrl: null,
    throttleMs: 2000,
  });

  // Unlock audio on first user click (required by browser autoplay policy).
  useEffect(() => {
    const onGesture = () => {
      unlockAudio?.();
    };
    window.addEventListener('click', onGesture, { once: true });
    window.addEventListener('keydown', onGesture, { once: true });
    return () => {
      window.removeEventListener('click', onGesture);
      window.removeEventListener('keydown', onGesture);
    };
  }, [unlockAudio]);

  // Primary path: toast + sound + order refresh fire directly from Web PubSub.
  // No Channels gating, no reconnect suppression, no dependency on REACT_APP_SOCKET_URL.
  const handlePubSubNewOrder = useCallback(
    (payload) => {
      // Guard: never treat cancellations as new orders (hook should already filter).
      const eventType = String(payload?.event || '').toLowerCase();
      if (
        eventType === 'order_cancelled' ||
        String(payload?.message || '').toLowerCase() === 'order cancelled'
      ) {
        return;
      }

      console.log('📦 Web PubSub new order event', payload);
      const orderKey = payload?.order_id || payload?.checkout_id || JSON.stringify(payload);
      if (processedOrderIdsRef.current.has(`pubsub:${orderKey}`)) {
        console.log('⏭️ Skipping duplicate PubSub notification for', orderKey);
        return;
      }
      processedOrderIdsRef.current.add(`pubsub:${orderKey}`);

      const orderId = payload?.order_id;
      console.log('🔔 PubSub → toast + sound + refresh', { orderId, orderKey });

      try {
        if (toast?.current?.show) {
          toast.current.show({
            severity: 'info',
            summary: 'New Order',
            detail: orderId ? `Order ${orderId}` : 'New order arrived',
            life: 5000,
          });
        } else {
          console.warn('⚠️ Toast ref not ready — order toast skipped');
        }
      } catch (toastErr) {
        console.warn('⚠️ Toast failed:', toastErr);
      }

      pubSubNotificationAtRef.current = Date.now();
      try {
        playOrderSound();
      } catch (soundErr) {
        console.warn('⚠️ playOrderSound failed:', soundErr);
      }

      try {
        refreshOrdersList();
      } catch (refreshErr) {
        console.warn('⚠️ refreshOrdersList failed:', refreshErr);
      }
    },
    [playOrderSound, refreshOrdersList]
  );

  // Cancellation: toast + list refresh only (no new-order alarm sound — matches admin cancel UX).
  const handlePubSubOrderCancelled = useCallback(
    (payload) => {
      console.log('🚫 Web PubSub order cancelled event', payload);
      const orderKey = payload?.order_id || payload?.checkout_id || JSON.stringify(payload);
      if (processedOrderIdsRef.current.has(`pubsub-cancel:${orderKey}`)) {
        console.log('⏭️ Skipping duplicate PubSub cancel notification for', orderKey);
        return;
      }
      processedOrderIdsRef.current.add(`pubsub-cancel:${orderKey}`);

      const orderId = payload?.order_id;
      console.log('🔔 PubSub cancel → toast + refresh', { orderId, orderKey });

      try {
        if (toast?.current?.show) {
          toast.current.show({
            severity: 'warn',
            summary: 'Order Cancelled',
            detail: orderId ? `Order ${orderId} was cancelled` : 'An order was cancelled',
            life: 5000,
          });
        }
      } catch (toastErr) {
        console.warn('⚠️ Cancel toast failed:', toastErr);
      }

      try {
        refreshOrdersList();
      } catch (refreshErr) {
        console.warn('⚠️ refreshOrdersList failed after cancel:', refreshErr);
      }
    },
    [refreshOrdersList]
  );

  const { isConnected, error: pubSubError } = useWebPubSubOrders({
    enabled: Boolean(authToken),
    onNewOrder: handlePubSubNewOrder,
    onOrderCancelled: handlePubSubOrderCancelled,
  });

  useEffect(() => {
    if (isConnected) {
      console.log('📡 Admin order notifications: Web PubSub connected');
    }
  }, [isConnected]);

  useEffect(() => {
    if (pubSubError) {
      console.warn('⚠️ Web PubSub error:', pubSubError);
    }
  }, [pubSubError]);

  useEffect(() => {
    return () => {
      if (pubSubBatchTimeoutRef.current) {
        clearTimeout(pubSubBatchTimeoutRef.current);
      }
    };
  }, []);

  // Helper function to play audio (prevents duplicates from PubSub orders)
  const playAudioIfNotWebSocket = useCallback(() => {
    if (Date.now() - pubSubNotificationAtRef.current < 5000) {
      return false;
    }
    playOrderSound();
    return true;
  }, [playOrderSound]);

  // Helper function to show toast for total orders (prevents duplicates)
  const showTotalOrdersToast = useCallback(() => {
    if (Date.now() - pubSubNotificationAtRef.current < 5000) {
      return false;
    }
    // Skip if toast was already shown for this refresh cycle
    if (toastShownForCurrentRefreshRef.current) {
       //console.log('⏭️ Skipping duplicate toast - already shown for this refresh cycle');
      return false;
    }
    
    // Mark that toast will be shown
    toastShownForCurrentRefreshRef.current = true;
    
    // Get total pending orders count
    const totalPendingOrders = orders.filter(order => order.status === 'pending').length;
    
    // Show toast notification with total pending orders
    if (totalPendingOrders === 1) {
      toast.current?.show({
        severity: 'info',
        summary: 'New Order',
        detail: `1 order pending`,
        life: 5000,
      });
    } else {
      toast.current?.show({
        severity: 'info',
        summary: 'New Orders',
        detail: `${totalPendingOrders} orders pending`,
        life: 8000,
      });
    }
    
    return true;
  }, [orders]);

  const selectedStalls = useSelector(state => state.orders.selectedStalls); // Track stall filter changes
  const showStallFilter = useSelector(state => state.orders.showStallFilter); // Track stall filter visibility

  // Listen to network online/offline events to track order count when network comes back
  useEffect(() => {
    const handleOnline = () => {
       //console.log('🌐 Network connection restored (before Web PubSub reconnects)');
      // Store order count when network comes back (before PubSub reconnects)
      const currentOrderCount = orders?.length || 0;
      orderCountWhenNetworkBackRef.current = currentOrderCount;
      networkCameBackRef.current = true;
       //console.log(`📊 Order count when network back: ${currentOrderCount} orders`);
    };

    const handleOffline = () => {
       //console.log('📴 Network connection lost');
      networkCameBackRef.current = false;
      orderCountWhenNetworkBackRef.current = 0;
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [orders]);

  // Update Redux socket status and track disconnection state
  useEffect(() => {
    dispatch(updatesocketStatus(isConnected));
    
    // Track disconnection state
    if (!isConnected) {
      // Snapshot current order IDs BEFORE disconnection
      // Only update snapshot if we're actually connected (not already disconnected)
      // IMPORTANT: Take snapshot from orders state, NOT from lastKnownOrderIdsRef
      // because lastKnownOrderIdsRef might have been updated by WebSocket messages
      // that arrived just before disconnection
      if (wasDisconnectedRef.current === false) {
        // Build snapshot from current orders state (most reliable source)
        // This ensures we capture the state BEFORE any WebSocket race conditions
        const snapshotIds = new Set();
        const currentOrders = orders || [];
        if (currentOrders.length > 0) {
          currentOrders.forEach(order => {
            if (order.status === 'pending') {
              if (order.id) snapshotIds.add(order.id);
              if (order.order_id) snapshotIds.add(order.order_id);
            }
          });
          snapshotBeforeDisconnectRef.current = snapshotIds;
           //console.log('📴 Connection lost - snapshot saved:', snapshotBeforeDisconnectRef.current.size, 'order IDs');
           //console.log('   Snapshot contents (first 10):', Array.from(snapshotBeforeDisconnectRef.current).slice(0, 10));
           //console.log('   Source: Current orders state (to avoid WebSocket race conditions)');
        } else {
          // Fallback: use lastKnownOrderIdsRef if orders state not available
          snapshotBeforeDisconnectRef.current = new Set(lastKnownOrderIdsRef.current);
           //console.log('📴 Connection lost - snapshot saved (fallback):', snapshotBeforeDisconnectRef.current.size, 'order IDs');
        }
      }
      wasDisconnectedRef.current = true;
    } else if (wasDisconnectedRef.current && isConnected) {
       //console.log('✅ Connection restored - orders will be fetched and checked for missed orders');
    }
  }, [isConnected, dispatch, orders, playOrderSound]);

  
  // Enterprise-grade order recovery: localStorage tracking
  const LAST_FETCHED_AT_KEY = 'orderNotification_lastFetchedAt';
  const LAST_ORDER_ID_KEY = 'orderNotification_lastOrderId';
  const LAST_ORDER_COUNT_KEY = 'orderNotification_lastOrderCount';

  /**
   * Save last fetch timestamp and order info to localStorage
   */
  const saveLastFetchedInfo = useCallback((orderIds, orderCount) => {
    try {
      const timestamp = new Date().toISOString();
      localStorage.setItem(LAST_FETCHED_AT_KEY, timestamp);
      
      // Save highest order ID (for comparison)
      const numericIds = Array.from(orderIds).filter(id => typeof id === 'number');
      const stringIds = Array.from(orderIds).filter(id => typeof id === 'string');
      const maxNumericId = numericIds.length > 0 ? Math.max(...numericIds) : null;
      const maxStringId = stringIds.length > 0 ? stringIds.sort().reverse()[0] : null;
      
      if (maxNumericId !== null) {
        localStorage.setItem(LAST_ORDER_ID_KEY, String(maxNumericId));
      }
      if (maxStringId !== null) {
        localStorage.setItem(`${LAST_ORDER_ID_KEY}_string`, maxStringId);
      }
      
      localStorage.setItem(LAST_ORDER_COUNT_KEY, String(orderCount));
      
       //console.log('💾 Saved last fetched info:', {
      //   timestamp,
      //   maxNumericId,
      //   maxStringId,
      //   orderCount
      // });
    } catch (err) {
      console.warn('⚠️ Failed to save last fetched info:', err);
    }
  }, []);

  /**
   * Get last fetched info from localStorage
   */
  const getLastFetchedInfo = useCallback(() => {
    try {
      const timestamp = localStorage.getItem(LAST_FETCHED_AT_KEY);
      const lastOrderId = localStorage.getItem(LAST_ORDER_ID_KEY);
      const lastOrderIdString = localStorage.getItem(`${LAST_ORDER_ID_KEY}_string`);
      const lastOrderCount = parseInt(localStorage.getItem(LAST_ORDER_COUNT_KEY) || '0', 10);
      
      return {
        timestamp: timestamp ? new Date(timestamp) : null,
        lastOrderId: lastOrderId ? parseInt(lastOrderId, 10) : null,
        lastOrderIdString,
        lastOrderCount
      };
    } catch (err) {
      console.warn('⚠️ Failed to get last fetched info:', err);
      return { timestamp: null, lastOrderId: null, lastOrderIdString: null, lastOrderCount: 0 };
    }
  }, []);

  // Refresh orders when connection is established (only once per connection)
  useEffect(() => {
    if (isConnected && !hasRefreshedOrdersRef.current) {
      hasRefreshedOrdersRef.current = true;
       //console.log('🔄 Fetching orders after reconnection...');
      
      // Save current orders state BEFORE refresh to detect new orders after refresh
      const currentOrderIds = new Set();
      if (orders && orders.length > 0) {
        orders.forEach(order => {
          if (order.status === 'pending') {
            if (order.id) currentOrderIds.add(order.id);
            if (order.order_id) currentOrderIds.add(order.order_id);
          }
        });
      }
      ordersBeforeRefreshRef.current = currentOrderIds;
       //console.log('📸 Snapshot before refresh:', Array.from(ordersBeforeRefreshRef.current).slice(0, 10), `(${ordersBeforeRefreshRef.current.size} total)`);
      
      // Get last fetched info for comparison
      const lastFetchedInfo = getLastFetchedInfo();
       //console.log('📊 Last fetched info:', lastFetchedInfo);
      
      if (orderDate != null) {
        GetOrders(orderDate[0], orderDate[1]);
      } else {
        GetOrders(today, today);
      }
    } else if (!isConnected) {
      // Reset flag when disconnected so we refresh again on next connection
      hasRefreshedOrdersRef.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConnected, getLastFetchedInfo]); // Only depend on isConnected to prevent re-renders

  // Track orders before stall filter effect is triggered (for new order detection)
  useEffect(() => {
    // Save current orders state BEFORE stall filter effect processes
    // This helps detect new orders that appear after stall filter is reset
    const currentOrderIds = new Set();
    if (orders && orders.length > 0) {
      orders.forEach(order => {
        if (order.status === 'pending') {
          if (order.id) currentOrderIds.add(order.id);
          if (order.order_id) currentOrderIds.add(order.order_id);
        }
      });
    }
    
    // Store snapshot before stall filter effect (will be used for comparison after)
    // Only update if we have orders (avoid clearing on empty state)
    if (currentOrderIds.size > 0 || ordersBeforeStallFilterRef.current.size === 0) {
      ordersBeforeStallFilterRef.current = new Set(currentOrderIds);
    }
  }, [selectedStalls, showStallFilter]); // Trigger when stall filter changes
  
  // Compare order count when network back vs after WebSocket connects and orders update
  // This runs when orders state changes after WebSocket connects
  useEffect(() => {
    // Only check if network came back and WebSocket is connected
    if (networkCameBackRef.current && isConnected && orderCountWhenNetworkBackRef.current > 0) {
      const currentOrderCount = orders?.length || 0;
      const orderCountWhenNetworkBack = orderCountWhenNetworkBackRef.current;
      
      // Only proceed if current count is greater (new orders detected)
      if (currentOrderCount > orderCountWhenNetworkBack) {
        const newOrderCount = currentOrderCount - orderCountWhenNetworkBack;
        
         //console.log('📊 Comparing order counts (after WebSocket connects and orders update):');
         //console.log(`   When network back: ${orderCountWhenNetworkBack} orders`);
         //console.log(`   After WebSocket connects: ${currentOrderCount} orders`);
         //console.log(`🆕 Detected ${newOrderCount} new order(s) after WebSocket connection!`);
         //console.log(`   Order count increased: ${orderCountWhenNetworkBack} → ${currentOrderCount}`);
        
        // Skip if PubSub already handled toast/sound recently (playAudioIfNotWebSocket / showTotalOrdersToast guard).
        playAudioIfNotWebSocket();
        showTotalOrdersToast();
        
        // Reset the flag after processing
        networkCameBackRef.current = false;
        orderCountWhenNetworkBackRef.current = 0;
      } else if (currentOrderCount === orderCountWhenNetworkBack) {
        // No new orders - reset flag
         //console.log('✅ No new orders detected (order count unchanged)');
        networkCameBackRef.current = false;
        orderCountWhenNetworkBackRef.current = 0;
      }
      // If currentCount < networkBackCount, don't reset (might be filtering or other state changes)
    }
  }, [orders, isConnected, playOrderSound]);

  // Detect and play audio for new orders after reconnection
  useEffect(() => {
    // Reset toast flag at the start of each orders state change
    toastShownForCurrentRefreshRef.current = false;
    
    // Get current pending order IDs (store both id and order_id for each order)
    const currentPendingOrderIds = [];
    if (orders && orders.length > 0) {
      orders.forEach(order => {
        if (order.status === 'pending') {
          if (order.id) currentPendingOrderIds.push(order.id);
          if (order.order_id) currentPendingOrderIds.push(order.order_id);
        }
      });
    }
    
    const currentTotalOrders = orders?.length || 0;
    const previousTotalOrders = previousTotalOrdersRef.current;
    const totalOrdersChanged = currentTotalOrders !== previousTotalOrders;
    
     //console.log('📋 Orders state check:', {
    //   totalOrders: currentTotalOrders,
    //   previousTotalOrders: previousTotalOrders,
    //   totalOrdersChanged: totalOrdersChanged,
    //   pendingOrders: currentPendingOrderIds.length,
    //   wasDisconnected: wasDisconnectedRef.current,
    //   isConnected,
    //   snapshotSize: snapshotBeforeDisconnectRef.current.size,
    //   hasOrders: !!(orders && orders.length > 0),
    //   selectedStalls: selectedStalls?.length || 0,
    //   showStallFilter: showStallFilter
    // });
    
    // ============================================================
    // MISSED ORDER DETECTION: Only runs when reconnecting after offline
    // ============================================================
    // This logic is SEPARATE from real-time WebSocket orders
    // It only processes orders that arrived while the connection was offline
    
    // IMPORTANT: Check if we have a snapshot AND we're connected (meaning we just reconnected)
    // We need BOTH conditions: snapshot exists (we were disconnected) AND isConnected (we're back online)
    const hasSnapshot = snapshotBeforeDisconnectRef.current.size > 0;
    const shouldDetect = hasSnapshot && isConnected && orders && orders.length > 0;
    
    if (shouldDetect) {
      // Ensure wasDisconnectedRef is true if we have a snapshot (defensive check)
      if (!wasDisconnectedRef.current) {
         //console.log('⚠️ Warning: Snapshot exists but wasDisconnectedRef is false - fixing...');
        wasDisconnectedRef.current = true;
      }
      
      // Use snapshot from before disconnection to compare with current orders
      // IMPORTANT: Create a copy to avoid accidental mutations
      const snapshot = new Set(snapshotBeforeDisconnectRef.current);
      
       //console.log('🔍 Checking for missed orders after reconnection...');
       //console.log('   Snapshot before disconnect:', Array.from(snapshot).slice(0, 20), `(${snapshot.size} total)`);
       //console.log('   Current pending order IDs:', currentPendingOrderIds.slice(0, 20), `(${currentPendingOrderIds.length} total)`);
      
      
      // Find new orders (orders that weren't in the snapshot before disconnection)
      // If snapshot is empty (0 orders), ALL pending orders are considered "missed"
      const newOrders = orders.filter(order => {
        const orderId = order.id || order.order_id;
        if (!orderId || order.status !== 'pending') return false;
        
        // If snapshot is empty, all pending orders are considered new
        if (snapshot.size === 0) {
           //console.log(`   ✅ Order ${orderId} is new (snapshot was empty)`);
          return true;
        }
        
        // Check if order ID (or order_id) is not in snapshot
        // Handle both id and order_id fields for comparison
        // An order is "new" if NEITHER its id NOR its order_id is in the snapshot
        // This is because orders can have both fields, and we store both in snapshot
        const hasIdInSnapshot = order.id ? snapshot.has(order.id) : false;
        const hasOrderIdInSnapshot = order.order_id ? snapshot.has(order.order_id) : false;
        
        // Debug logging for this specific order
        const isNew = !hasIdInSnapshot && !hasOrderIdInSnapshot;
        
        if (isNew) {
           //console.log(`   ✅ Order ${orderId} (id: ${order.id}, order_id: ${order.order_id}) is NEW - not in snapshot`);
           //console.log(`      - id ${order.id} in snapshot: ${hasIdInSnapshot}`);
           //console.log(`      - order_id ${order.order_id} in snapshot: ${hasOrderIdInSnapshot}`);
        } else {
          // Debug: Show why it's NOT new
          if (hasIdInSnapshot || hasOrderIdInSnapshot) {
             //console.log(`   ⏭️ Order ${orderId} (id: ${order.id}, order_id: ${order.order_id}) is NOT new - already in snapshot`);
             //console.log(`      - id ${order.id} in snapshot: ${hasIdInSnapshot}`);
             //console.log(`      - order_id ${order.order_id} in snapshot: ${hasOrderIdInSnapshot}`);
          }
        }
        return isNew;
      });
      
       //console.log(`📊 Detection result: Found ${newOrders.length} new order(s) to process`);
      
      if (newOrders.length > 0) {
         //console.log(`🆕 MISSED ORDERS DETECTED: ${newOrders.length} order(s) arrived while offline!`);
         //console.log('   New order details:', newOrders.map(o => ({ 
        //   id: o.id || o.order_id, 
        //   status: o.status 
        // })));
        
        // Clear any existing missed order timeouts (in case of rapid reconnections)
        missedOrderTimeoutsRef.current.forEach(timeout => clearTimeout(timeout));
        missedOrderTimeoutsRef.current = [];
        
        // Filter out already processed orders (prevent duplicates on rapid reconnections)
        const unprocessedOrders = newOrders.filter(order => {
          const orderId = order.id || order.order_id;
          if (processedOrderIdsRef.current.has(orderId)) {
             //console.log(`⏭️ Order ${orderId} already processed, skipping`);
            return false;
          }
          processedOrderIdsRef.current.add(orderId);
          return true;
        });
        
        if (unprocessedOrders.length === 0) {
           //console.log('✅ All missed orders were already processed');
          wasDisconnectedRef.current = false;
          snapshotBeforeDisconnectRef.current = new Set();
          return;
        }
        
        // ============================================================
        // PLAY AUDIO ONCE FOR MISSED ORDERS
        // ============================================================
        // Play audio only once regardless of number of missed orders
         //console.log(`🔊 Will play audio once for ${unprocessedOrders.length} missed order(s)...`);
        
        // Play audio once (missed orders are not from WebSocket, so always play)
        playOrderSound();
        
        // Show toast (will prevent duplicates automatically)
        showTotalOrdersToast();
        
        // Reset disconnection flag after processing (prevents re-processing)
        wasDisconnectedRef.current = false;
        snapshotBeforeDisconnectRef.current = new Set(); // Clear snapshot
        
        // NOW update lastKnownOrderIds with ALL current orders (including the newly detected ones)
        const allOrderIds = new Set();
        orders.forEach(order => {
          if (order.status === 'pending') {
            if (order.id) allOrderIds.add(order.id);
            if (order.order_id) allOrderIds.add(order.order_id);
          }
        });
             lastKnownOrderIdsRef.current = allOrderIds;
             lastProcessedOrderIdsRef.current = new Set(allOrderIds); // Also update processed IDs
             
             // Save to localStorage for order recovery
             saveLastFetchedInfo(allOrderIds, currentTotalOrders);
             
              //console.log('💾 Updated lastKnownOrderIds after missed order detection:', Array.from(lastKnownOrderIdsRef.current));
              //console.log('✅ Missed order detection completed. Real-time orders will continue to work normally.');
      } else {
         //console.log('✅ No missed orders found (all orders were already known before disconnection)');
        // Still reset the flag even if no new orders
        wasDisconnectedRef.current = false;
        snapshotBeforeDisconnectRef.current = new Set();
        
        // Update lastKnownOrderIds now that detection is complete
        const allOrderIds = new Set();
        orders.forEach(order => {
          if (order.status === 'pending') {
            if (order.id) allOrderIds.add(order.id);
            if (order.order_id) allOrderIds.add(order.order_id);
          }
        });
             lastKnownOrderIdsRef.current = allOrderIds;
             lastProcessedOrderIdsRef.current = new Set(allOrderIds); // Also update processed IDs
             
             // Save to localStorage for order recovery
             saveLastFetchedInfo(allOrderIds, currentTotalOrders);
             
              //console.log('💾 Updated lastKnownOrderIds after detection (no missed orders):', Array.from(lastKnownOrderIdsRef.current));
      }
    } else if (hasSnapshot && !isConnected) {
      // Still disconnected - don't clear snapshot yet
       //console.log('⏳ Still disconnected - keeping snapshot for detection when connection is restored');
    } else if (!hasSnapshot && wasDisconnectedRef.current && isConnected) {
      // Connection restored but snapshot was already cleared - this shouldn't happen
      // console.warn('⚠️ Warning: Connection restored but snapshot was already cleared. Detection may have been skipped.');
      wasDisconnectedRef.current = false;
    }
    
    // Real-time orders: toast + sound via handlePubSubNewOrder (Web PubSub).
    // Below: missed-order / API-refresh detection after PubSub reconnect.

    if (true) {
      // Store both id and order_id for each order to handle both field types
      const allOrderIds = new Set();
      orders.forEach(order => {
        if (order.status === 'pending') {
          if (order.id) allOrderIds.add(order.id);
          if (order.order_id) allOrderIds.add(order.order_id);
        }
      });
      
      // Check for new orders that appeared in Redux state (from API refresh, WebSocket reconnection, or stall filter)
      // Multiple detection strategies:
      // 1. Compare totalOrders count (quick detection) - PRIMARY STRATEGY
      // 2. Compare before/after refresh snapshot (accurate detection)
      // 3. Compare before/after stall filter (when stall filter is reset)
      // 4. Compare with last processed IDs (fallback)
      if (isConnected && allOrderIds.size > 0) {
        let shouldCheckForNewOrders = false;
        let beforeRefreshIds = new Set();
        
        // Strategy 1: Check if totalOrders count changed (quick indicator) - PRIMARY
        // This catches ALL cases: API refresh, WebSocket reconnection, stall filter reset
        if (totalOrdersChanged && currentTotalOrders > previousTotalOrders) {
           //console.log(`📊 Total orders changed: ${previousTotalOrders} → ${currentTotalOrders} (detected new orders!)`);
          shouldCheckForNewOrders = true;
          
          // Calculate new order count immediately
          const newOrderCountFromChange = currentTotalOrders - previousTotalOrders;
          
          // Priority order for choosing "before" state:
          // 1. orderCountWhenNetworkBackRef (when network came back - most accurate for reconnection)
          // 2. ordersBeforeRefreshRef (after API refresh - IMPORTANT: check this even if previousTotalOrders is 0)
          // 3. ordersBeforeStallFilterRef (most recent - after stall filter effect)
          // 4. lastProcessedOrderIdsRef (fallback)
          // 5. Use order count comparison if network came back (even without IDs)
          
          // Priority 1: Check ordersBeforeRefreshRef FIRST (most reliable for API refresh)
          // This is set when GetOrders() is called, so it's the most accurate snapshot
          if (ordersBeforeRefreshRef.current.size > 0) {
            beforeRefreshIds = ordersBeforeRefreshRef.current;
             //console.log('   ✅ Using ordersBeforeRefreshRef for comparison (after API refresh)');
             //console.log(`   Before refresh: ${beforeRefreshIds.size} order IDs`);
            // Continue to ID-based comparison below
          } 
          // Priority 2: Check network back count (for reconnection scenarios)
          else if (networkCameBackRef.current && orderCountWhenNetworkBackRef.current > 0) {
            // Network came back - use count comparison (more reliable than IDs in this case)
            const orderCountWhenNetworkBack = orderCountWhenNetworkBackRef.current;
            if (currentTotalOrders > orderCountWhenNetworkBack) {
              const newOrderCount = currentTotalOrders - orderCountWhenNetworkBack;
               //console.log(`🆕 Detected ${newOrderCount} new order(s) using network back count comparison!`);
               //console.log(`   Order count: ${orderCountWhenNetworkBack} (when network back) → ${currentTotalOrders} (current)`);
              
              // Play audio once (will check WebSocket flag internally)
              playAudioIfNotWebSocket();
              
              // Show toast (will prevent duplicates automatically)
              showTotalOrdersToast();
              
              // Reset the flag after processing
              networkCameBackRef.current = false;
              orderCountWhenNetworkBackRef.current = 0;
              
              // Update previousTotalOrders to prevent duplicate detection
              previousTotalOrdersRef.current = currentTotalOrders;
              
              // Skip ID-based comparison since we already handled it with count
              shouldCheckForNewOrders = false;
            } else {
              // No new orders based on count - reset flag
              networkCameBackRef.current = false;
              orderCountWhenNetworkBackRef.current = 0;
            }
          } 
          // Check ordersBeforeStallFilterRef
          else if (ordersBeforeStallFilterRef.current.size > 0) {
            beforeRefreshIds = ordersBeforeStallFilterRef.current;
             //console.log('   Using ordersBeforeStallFilterRef for comparison');
            // Continue to ID-based comparison below
          } 
          // Check lastProcessedOrderIdsRef
          else if (lastProcessedOrderIdsRef.current.size > 0) {
            beforeRefreshIds = lastProcessedOrderIdsRef.current;
             //console.log('   Using lastProcessedOrderIdsRef for comparison');
            // Continue to ID-based comparison below
          } 
          // Fallback: use previousTotalOrders count if available
          else if (previousTotalOrders > 0) {
            // We have a previous count but no IDs - use count comparison
            const newOrderCount = currentTotalOrders - previousTotalOrders;
             //console.log(`🆕 Detected ${newOrderCount} new order(s) using previousTotalOrders count!`);
             //console.log(`   Order count: ${previousTotalOrders} → ${currentTotalOrders}`);
            
            // Play audio once (will check WebSocket flag internally)
            playAudioIfNotWebSocket();
            
            // Show toast (will prevent duplicates automatically)
            if (showTotalOrdersToast()) {
              // Update previousTotalOrders only if toast was shown
              previousTotalOrdersRef.current = currentTotalOrders;
            }
            
            shouldCheckForNewOrders = false;
          } 
          // Last resort: if previousTotalOrders is 0 and we have current orders
          // But if totalOrdersChanged is true, we should still play sound for the difference
          else if (previousTotalOrders === 0 && currentTotalOrders > 0) {
            // Check if we have any snapshot data to use
            if (ordersBeforeRefreshRef.current.size > 0 || 
                ordersBeforeStallFilterRef.current.size > 0 || 
                lastProcessedOrderIdsRef.current.size > 0) {
              // We have snapshot data - let it fall through to Strategy 2/3/4 below
               //console.log('⚠️ Initial load but have snapshot data - will use ID comparison');
              shouldCheckForNewOrders = true;
              // Try to use any available snapshot
              if (ordersBeforeRefreshRef.current.size > 0) {
                beforeRefreshIds = ordersBeforeRefreshRef.current;
              } else if (ordersBeforeStallFilterRef.current.size > 0) {
                beforeRefreshIds = ordersBeforeStallFilterRef.current;
              } else if (lastProcessedOrderIdsRef.current.size > 0) {
                beforeRefreshIds = lastProcessedOrderIdsRef.current;
              }
            } else {
              // No snapshot data - this is likely initial load
              // But if totalOrdersChanged is true, play sound for the difference
              const newOrderCount = currentTotalOrders - previousTotalOrders;
              if (newOrderCount > 0) {
                 //console.log(`🆕 Detected ${newOrderCount} new order(s) from count change (no snapshot available)!`);
                 //console.log(`   Order count: ${previousTotalOrders} → ${currentTotalOrders}`);
                
                // Play audio once (will check WebSocket flag internally)
                playAudioIfNotWebSocket();
                
                // Show toast (will prevent duplicates automatically)
                if (showTotalOrdersToast()) {
                  // Update previousTotalOrders only if toast was shown
                  previousTotalOrdersRef.current = currentTotalOrders;
                }
              }
              shouldCheckForNewOrders = false;
            }
          } 
          else {
            // No previous state available at all - but count changed, so play sound
             //console.log(`🆕 Detected ${newOrderCountFromChange} new order(s) from count change (no previous state)!`);
             //console.log(`   Order count: ${previousTotalOrders} → ${currentTotalOrders}`);
            
            // Play audio once (will check WebSocket flag internally)
            playAudioIfNotWebSocket();
            
            // Show toast (will prevent duplicates automatically)
            if (showTotalOrdersToast()) {
              // Update previousTotalOrders only if toast was shown
              previousTotalOrdersRef.current = currentTotalOrders;
            }
            shouldCheckForNewOrders = false;
          }
        }
        
        // FALLBACK: If totalOrdersChanged is true but no detection method worked, play sound based on count
        // This ensures sound ALWAYS plays when orders increase, even if no snapshot is available
        // This is a safety net to ensure we never miss playing sound when orders increase
        if (totalOrdersChanged && currentTotalOrders > previousTotalOrders && !shouldCheckForNewOrders) {
          // No ID comparison will happen - use count-based detection as fallback
          const newOrderCount = currentTotalOrders - previousTotalOrders;
          
          // Only play if previousTotalOrders hasn't been updated yet (meaning sound wasn't played)
          // Check the original previousTotalOrders value (before any updates)
          const originalPreviousTotal = previousTotalOrders; // This is the value before any updates
          
          if (newOrderCount > 0) {
             //console.log(`🆕 FALLBACK: Playing sound for ${newOrderCount} new order(s) based on count change`);
             //console.log(`   Order count: ${originalPreviousTotal} → ${currentTotalOrders}`);
             //console.log(`   Condition: totalOrdersChanged=${totalOrdersChanged}, shouldCheckForNewOrders=${shouldCheckForNewOrders}`);
            
            // Play audio once (will check WebSocket flag internally)
            playAudioIfNotWebSocket();
            
            // Show toast (will prevent duplicates automatically)
            if (showTotalOrdersToast()) {
              // Update previousTotalOrders only if toast was shown
              previousTotalOrdersRef.current = currentTotalOrders;
            }
          }
        }
        
        // Strategy 2: Use before/after refresh snapshot (if available)
        if (!shouldCheckForNewOrders && ordersBeforeRefreshRef.current.size > 0) {
          beforeRefreshIds = ordersBeforeRefreshRef.current;
          shouldCheckForNewOrders = true;
        }
        
        // Strategy 3: Use before/after stall filter snapshot (if available)
        if (!shouldCheckForNewOrders && ordersBeforeStallFilterRef.current.size > 0) {
          beforeRefreshIds = ordersBeforeStallFilterRef.current;
          shouldCheckForNewOrders = true;
        }
        
        // Strategy 4: Compare with last processed IDs (fallback)
        if (!shouldCheckForNewOrders && lastProcessedOrderIdsRef.current.size > 0) {
          beforeRefreshIds = lastProcessedOrderIdsRef.current;
          shouldCheckForNewOrders = true;
        }
        
        if (shouldCheckForNewOrders && beforeRefreshIds.size > 0) {
          const newOrderIds = [];
          allOrderIds.forEach(id => {
            if (!beforeRefreshIds.has(id)) {
              newOrderIds.push(id);
            }
          });
          
           //console.log('🔍 ID-based comparison:', {
          //   beforeRefreshIds: beforeRefreshIds.size,
          //   currentOrderIds: allOrderIds.size,
          //   newOrderIds: newOrderIds.length,
          //   newOrderIdsList: newOrderIds
          // });
          
          if (newOrderIds.length > 0) {
             //console.log(`🆕 Detected ${newOrderIds.length} new order ID(s) from API refresh/WebSocket reconnection!`);
             //console.log('   Total orders changed:', `${previousTotalOrders} → ${currentTotalOrders}`);
             //console.log('   Before refresh:', Array.from(beforeRefreshIds).slice(0, 10), `(${beforeRefreshIds.size} total IDs)`);
             //console.log('   After refresh:', Array.from(allOrderIds).slice(0, 10), `(${allOrderIds.size} total IDs)`);
             //console.log('   New order IDs:', newOrderIds);
            
            // Find the actual order objects for these new IDs
            const newOrders = orders.filter(order => {
              if (order.status !== 'pending') return false;
              const orderId = order.id || order.order_id;
              // Check if this order's ID or order_id is in the newOrderIds list
              return newOrderIds.includes(orderId) || 
                     (order.id && newOrderIds.includes(order.id)) ||
                     (order.order_id && newOrderIds.includes(order.order_id));
            });
            
             //console.log(`   Found ${newOrders.length} new order object(s) to process`);
            
            if (newOrders.length > 0) {
              // Mark orders as processed
              newOrders.forEach((order) => {
                const orderId = order.id || order.order_id;
                if (!processedOrderIdsRef.current.has(orderId)) {
                  processedOrderIdsRef.current.add(orderId);
                }
              });
              
              // Skip if PubSub already handled toast/sound recently.
              playAudioIfNotWebSocket();
              showTotalOrdersToast();
            } else {
              console.warn('⚠️ Found new order IDs but no matching order objects - this should not happen');
            }
            
            // Clear the before refresh snapshot after processing
            ordersBeforeRefreshRef.current = new Set();
            ordersBeforeStallFilterRef.current = new Set(); // Also clear stall filter snapshot
          } else {
            // No new orders - clear the snapshots
             //console.log('✅ No new orders found in ID comparison');
            ordersBeforeRefreshRef.current = new Set();
            ordersBeforeStallFilterRef.current = new Set();
          }
        }
        
        // FINAL FALLBACK: If totalOrdersChanged is true but no sound was played yet, play sound based on count
        // This ensures sound ALWAYS plays when orders increase, regardless of detection method
        // Check if we still have the condition true and no sound was played
        if (totalOrdersChanged && currentTotalOrders > previousTotalOrders) {
          // Check if previousTotalOrders was updated (meaning sound was already played)
          const wasUpdated = previousTotalOrdersRef.current === currentTotalOrders;
          
          if (!wasUpdated) {
            // Sound wasn't played yet - play it now based on count
            const newOrderCount = currentTotalOrders - previousTotalOrders;
            
             //console.log(`🆕 FINAL FALLBACK: Playing sound for ${newOrderCount} new order(s) based on count change`);
             //console.log(`   Order count: ${previousTotalOrders} → ${currentTotalOrders}`);
             //console.log(`   Condition: totalOrdersChanged=${totalOrdersChanged}`);
            
            // Play audio once (will check WebSocket flag internally)
            playAudioIfNotWebSocket();
            
            // Show toast (will prevent duplicates automatically)
            if (showTotalOrdersToast()) {
              // Update previousTotalOrders only if toast was shown
              previousTotalOrdersRef.current = currentTotalOrders;
            }
          }
        }
      }
      
      // Update previous totalOrders count for next comparison
      // IMPORTANT: Only update if we haven't already updated it in the detection logic above
      // This prevents overwriting the update that happened during detection
      if (previousTotalOrdersRef.current !== currentTotalOrders) {
        // Only update if it wasn't already updated by detection logic
        // Check if we already processed new orders (to avoid double updates)
        const wasUpdated = previousTotalOrdersRef.current === currentTotalOrders;
        if (!wasUpdated) {
          previousTotalOrdersRef.current = currentTotalOrders;
        }
      }
      
           // Update refs
           lastKnownOrderIdsRef.current = allOrderIds;
           lastProcessedOrderIdsRef.current = new Set(allOrderIds); // Track processed IDs
           
           // Save to localStorage for order recovery
           saveLastFetchedInfo(allOrderIds, currentTotalOrders);
           
            //console.log('💾 Updated lastKnownOrderIds:', Array.from(lastKnownOrderIdsRef.current));
         } else {
           // We're detecting missed orders - don't update lastKnownOrderIds yet
           // It will be updated after we finish processing missed orders
            //console.log('⏸️ Skipping lastKnownOrderIds update - missed order detection in progress');
         }
    
    // Cleanup: Clear timeouts on unmount or when orders change significantly
    return () => {
      missedOrderTimeoutsRef.current.forEach(timeout => clearTimeout(timeout));
      missedOrderTimeoutsRef.current = [];
    };
  }, [orders, isConnected, playOrderSound]);

  // Refresh orders when orderDate changes (separate effect)
  useEffect(() => {
    if (isConnected && orderDate != null && hasRefreshedOrdersRef.current) {
      GetOrders(orderDate[0], orderDate[1]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDate]); // Only depend on orderDate

  // useEffect(() => {
  //   if (page) {
  //     window.history.pushState({ page }, "", `#${page}`);
  //   }
  // }, [page]);

  // useEffect(() => {
  //   const handlePopState = (event) => {
  //     const pageFromHistory = event.state?.page || "dashboard";
  //     dispatch(updatepageName(pageFromHistory));
  //   };

  //   window.addEventListener("popstate", handlePopState);
  //   return () => window.removeEventListener("popstate", handlePopState);
  // }, []);

  return (<Box sx={{ width: "100%", height: "100vh", backgroundColor: 'background.default' }}>
    <Header />
    <Toast ref={toast} />
    <Box sx={{ display: "flex", height: 'calc( 100vh - 72px)', overflowY: 'auto' }}>
      {!isKioskPage && <Sidebar />}
      <Box sx={{ width: "100%" }}>
        <Outlet />
      </Box>

    </Box>
  </Box>)
}